import {Map as ImmutableMap} from 'immutable';

import {generateExperimentMap} from '../../modules/experiment/experimentUtils';

function generateDefaultInitialExperimentState() {
  return {
    appExperimentMap: ImmutableMap(),
  };
}

function experimentReducer(state = generateDefaultInitialExperimentState(), action) {
  let newState;

  switch (action.type) {
    case 'GET_APP_EXPERIMENTS_FULFILLED': {
      newState = {
        ...state,
        appExperimentMap: generateExperimentMap(
          action.payload.response,
        ),
      };

      break;
    }

    case 'GET_SEARCH_EXPERIMENTS_FULFILLED': {
      newState = {
        ...state,
        appExperimentMap: generateExperimentMap(
          action.payload.response,
        ),
      };

      break;
    }

    case 'GET_DESKTOP_SEARCH_EXPERIMENTS_FULFILLED': {
      newState = {
        ...state,
        appExperimentMap: generateExperimentMap(
          action.payload.response,
        ),
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}


export default experimentReducer;
export {generateDefaultInitialExperimentState};
